import { useEffect, useState } from "react";
import Loader from "../../components/Common/Loader";
import ReplaceRecipeModal from "./ReplaceRecipeModal";
import RecipeDrawer from "./RecipeDetailsDrawer";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchFavoriteRecipesThunk,
  fetchRecipesByNameThunk,
  postFavoriteRecipeThunk,
} from "../../redux/Slices/recipesListSlice";
import { CONSTANTS } from "../../utils/Constant/Constant";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import ToastNotification from "../../components/Common/ToastNotification";

const RecipesCard = ({
  isToolbox,
  recipe,
  filteredRecipes,
  recipesList,
  isClickedFromSwapRecipe = false,
  onClick,
  handleRecipeUpdate,
  mealType,
  selectedMeals,
  formData,
  exclude,
  mealPercentages,
  // is favorite toggle enabled
  isToggled,
  setMakeFavoriteMessage,
  dietaryPreferences,
  allergies,
  numberOfRecipesPerMeal,
}) => {
  const dispatch = useDispatch();
  const { trans } = useCustomTranslation();
  const { profileData } = useSelector((state) => state.profile);

  const [imageLoaded, setImageLoaded] = useState(false);
  const [showReplaceModal, setShowReplaceModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [selectedRecipeId, setSelectedRecipeId] = useState(null);
  const [selectedRecipe, setSelectedRecipe] = useState({});
  const [toastConfig, setToastConfig] = useState(null);
  const [toastMessage, setToastMessage] = useState("");

  const handleCardClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isClickedFromSwapRecipe) {
      onClick();
    } else {
      setShowReplaceModal(true);
    }
  };

  const handleInfoClick = (e) => {
    e.stopPropagation();
    let recipesId = recipe?.recipeId ? recipe?.recipeId : recipe?.id;
    setSelectedRecipeId(recipesId);
    setSelectedRecipe(recipe);
    setShowInfoModal(true);
  };

  // eslint-disable-next-line no-unused-vars
  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    const recipeId = recipe?.databaseId
      ? recipe?.databaseId
      : recipe.databaseId;
    const coachId = profileData?.coachId;

    dispatch(postFavoriteRecipeThunk({ coachId, recipeId })).then((result) => {
      if (result?.payload?.data?.userFavoriteRecipe) {
        const isFavorite =
          result.payload.data.userFavoriteRecipe.isUserFavorite;

        setMakeFavoriteMessage(
          isFavorite
            ? trans("ClientMealPlan.recipeFavoriteAdded")
            : trans("ClientMealPlan.recipeFavoriteRemoved")
        );

        isToolbox &&
          setMakeFavoriteMessage(
            isFavorite
              ? trans("ClientMealPlan.recipeFavoriteAdded")
              : trans("ClientMealPlan.recipeFavoriteRemoved")
          );
        const FilterData = {
          recipeName: "",
          mealTime: "",
          cuisines: [],
          tags: [],
          macroNutrientsRange: {},
          mealRestrictions: "",
        };

        // Make favorite and un-favorite api calls
        isToggled
          ? dispatch(fetchFavoriteRecipesThunk({ coachId }))
          : dispatch(fetchRecipesByNameThunk({ FilterData, coachId }));
      }
    });
  };

  const handleModalClose = () => {
    setShowReplaceModal(false);
  };

  // Toast notification logic
  useEffect(() => {
    if (!toastConfig && toastMessage !== "") {
      // Trigger success toast
      setToastConfig({
        type: CONSTANTS.TOAST_SUCCESS,
        message: toastMessage,
        heading: trans("Common.success"),
      });
      setTimeout(() => {
        setToastConfig(null);
        setToastMessage("");
      }, 3000);
    }
  }, [toastMessage, trans, toastConfig]);

  return (
    <>
      <div
        className="card recipe-card position-relative p-0"
        onClick={isToolbox ? handleInfoClick : handleCardClick}
        style={{
          cursor: "pointer",
          width: isToolbox ? "200px" : "auto",
          maxWidth: isToolbox ? "200px" : "200px",
          minWidth: isToolbox ? "200px" : "200px",
        }}
        key={recipe?.id}
      >
        {!isClickedFromSwapRecipe && (
          <div className="info-icon position-absolute top-0 end-0 p-2">
            <div className="d-flex justify-content-end position-absolute top-0 end-0 p-2 gap-2">
              {/* Heart Icon */}
              {/* <div onClick={handleFavoriteClick}>
                {recipe?.isUserFavorite === true ||
                recipe?.isUserFavorite === "true" ? (
                  <i className="bi bi-heart-fill text-danger"></i>
                ) : (
                  <i className="bi-heart text-white"></i>
                )}
              </div> */}

              {/* Info Icon */}
              <div onClick={handleInfoClick}>
                {!isToolbox && (
                  <i className="bi bi-info-circle-fill text-white"></i>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="recipe-overlay">
          <h6 className="card-title">{recipe?.title || recipe?.name}</h6>
          <div className="full-title">{recipe?.title || recipe?.name}</div>
        </div>

        {!imageLoaded && <Loader message="" />}

        <img
          src={recipe?.mainImage || "/placeholder-image.jpg"}
          alt={recipe?.title || recipe?.name}
          className={`card-img-top recipe-image ${
            imageLoaded ? "visible" : "hidden"
          }`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(true)}
        />
      </div>
      {showReplaceModal && (
        <ReplaceRecipeModal
          show={showReplaceModal}
          onHide={handleModalClose}
          selectedRecipes={filteredRecipes}
          recipesList={recipesList}
          handleRecipeUpdate={handleRecipeUpdate}
          mealType={mealType}
          selectedMeals={selectedMeals}
          formData={formData}
          exclude={exclude}
          mealPercentages={mealPercentages}
          allergies={allergies}
          dietaryPreferences={dietaryPreferences}
          numberOfRecipesPerMeal={numberOfRecipesPerMeal}
        />
      )}
      <RecipeDrawer
        recipeDetails={selectedRecipe}
        visible={showInfoModal}
        onClose={() => setShowInfoModal(false)}
      />

      {toastConfig && (
        <ToastNotification
          type={toastConfig.type}
          message={toastConfig.message}
          heading={toastConfig.heading}
        />
      )}
    </>
  );
};

export default RecipesCard;
